import React from 'react';
import './Services.css';

const services = [
  {
    id: 'mobile-app-development',
    title: 'Mobile App Development',
    desc: 'We create user-friendly mobile applications that run on both iOS and Android platforms.',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="28"
        height="28"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
      >
        <rect x="7" y="2" width="10" height="20" rx="2" ry="2" />
        <line x1="12" y1="18" x2="12.01" y2="18" />
      </svg>
    ),
  },
  {
    id: 'desktop-software-development',
    title: 'Desktop Software Development',
    desc: 'We build robust desktop applications that meet the highest standards of performance and usability.',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="28"
        height="28"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
      >
        <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
        <line x1="8" y1="21" x2="16" y2="21" />
        <line x1="12" y1="17" x2="12" y2="21" />
      </svg>
    ),
  },
  {
    id: 'web-development',
    title: 'Web Development',
    desc: 'Building responsive and accessible web applications.',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="28"
        height="28"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
      >
        <circle cx="12" cy="12" r="10" />
        <line x1="2" y1="12" x2="22" y2="12" />
        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
      </svg>
    ),
  },
  {
    id: 'ui-ux-design',
    title: 'UI/UX Design',
    desc: 'Creating user-centered designs that are both functional and aesthetically pleasing.',
    icon: (
      <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
        <path d="M12 2l2 5 5 .5-4 3 1.2 5L12 14l-4.2 2.5L9 10 5 7.2 10 6z" />
      </svg>
    ),
  },
];

export default function Services() {
  return (
    <section id="services" className="comp-section services" aria-labelledby="services-heading">
      <div className="services-wrap">
        <div className="services-head">
          <h2 id="services-heading">Our Services</h2>
          <p className="muted">We design and build modern software, platforms, and experiences that scale.</p>
        </div>

        <div className="grid" role="list">
          {services.map((s, idx) => (
            <article key={s.id} className="card service-card" role="listitem" style={{ animationDelay: `${idx * 80}ms` }}>
              <div className="icon" aria-hidden>
                {s.icon}
              </div>
              <div className="card-body">
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </div>
              <a className="learn" href={`#${s.id}`} aria-label={`Learn more about ${s.title}`}>Learn more →</a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
